import { BackednResponse } from "@shared/lib/types";
import { GetCampaignReachoutInfluencers } from "@shared/lib/types/campaignReachoutInfluencer";
import { useQuery } from "@tanstack/react-query";
import { CAMPAIGN_REACHOUT_INFLUENCER_KEY } from "../constants";
import { CampaignReachoutService } from "../services/campaign.reachout.service";
import { useEffect } from "react";
import { ToastService } from "@shared/lib/services";

export function useGetCampaignReachOuts(limit: number, pageNo: number) {
  const { data, isFetching, isError, error } = useQuery<
    BackednResponse<GetCampaignReachoutInfluencers>
  >({
    queryKey: [...CAMPAIGN_REACHOUT_INFLUENCER_KEY, limit, pageNo],
    queryFn: () =>
      CampaignReachoutService.getCampaignReachoutsInfluencer({
        limit,
        pageNo,
      }),
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    campaignReachouts: data?.data,
    isError,
    isFetching,
  };
}
